export const DEFAULT_TOAST_DURATION = 2600
